import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'
import { SeFeFormControlLabelModule } from 'se-fe-form-control-label'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SeFeSwitchModule } from 'se-fe-switch'
import { SeFeToastModule } from 'se-fe-toast'
import { SharedUiAddressModule } from '../lib/shared-ui-address.module'
import { AddressDocsComponent } from './address-docs/address-docs.component'
import { AddressExampleComponent } from './address-docs/examples/address-example.component'
import { PopulatedAddressExampleComponent } from './address-docs/examples/populated-address-example.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeFormControlLabelModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeFeSwitchModule,
    SeFeToastModule,
    SharedUiAddressModule
  ],
  declarations: [
    AddressDocsComponent,
    AddressExampleComponent,
    PopulatedAddressExampleComponent
  ],
  exports: [
    AddressDocsComponent
  ]
})
export class SharedUiAddressDocsModule {}
